import React, { createContext, useContext, useState, useEffect } from 'react';

const LanguageContext = createContext();

const translations = {
  en: {
    // Navigation
    dashboard: 'Dashboard',
    cases: 'Cases',
    clients: 'Clients',
    employees: 'Employees',
    finance: 'Finance',
    documents: 'Documents',
    calendar: 'Calendar',
    settings: 'Settings',
    logout: 'Logout',
    
    // Auth
    login: 'Login',
    username: 'Username',
    password: 'Password',
    loginButton: 'Sign In',
    loginError: 'Invalid credentials',
    welcomeBack: 'Welcome Back',
    signInToContinue: 'Sign in to continue to your dashboard',
    
    // Dashboard
    totalCases: 'Total Cases',
    activeCases: 'Active Cases',
    pendingCases: 'Pending Cases',
    closedCases: 'Closed Cases',
    totalClients: 'Total Clients',
    totalEmployees: 'Total Employees',
    totalIncome: 'Total Income',
    totalExpenses: 'Total Expenses',
    netProfit: 'Net Profit',
    recentCases: 'Recent Cases',
    upcomingEvents: 'Upcoming Events',
    financialOverview: 'Financial Overview',
    
    // Cases
    caseNumber: 'Case Number',
    caseTitle: 'Case Title',
    caseType: 'Case Type',
    caseStatus: 'Status',
    client: 'Client',
    assignedLawyer: 'Assigned Lawyer',
    courtName: 'Court Name',
    description: 'Description',
    notes: 'Notes',
    createCase: 'Create Case',
    editCase: 'Edit Case',
    deleteCase: 'Delete Case',
    caseDetails: 'Case Details',
    
    // Clients
    clientName: 'Client Name',
    email: 'Email',
    phone: 'Phone',
    address: 'Address',
    idNumber: 'ID Number',
    createClient: 'Create Client',
    editClient: 'Edit Client',
    deleteClient: 'Delete Client',
    clientDetails: 'Client Details',
    linkedCases: 'Linked Cases',
    
    // Employees
    fullName: 'Full Name',
    role: 'Role',
    admin: 'Admin',
    lawyer: 'Lawyer',
    assistant: 'Assistant',
    createEmployee: 'Create Employee',
    editEmployee: 'Edit Employee',
    deleteEmployee: 'Delete Employee',
    employeeDetails: 'Employee Details',
    
    // Finance
    income: 'Income',
    expense: 'Expense',
    amount: 'Amount',
    date: 'Date',
    category: 'Category',
    addTransaction: 'Add Transaction',
    transactionType: 'Transaction Type',
    financialReport: 'Financial Report',
    
    // Documents
    uploadDocument: 'Upload Document',
    fileName: 'File Name',
    fileSize: 'File Size',
    uploadDate: 'Upload Date',
    download: 'Download',
    delete: 'Delete',
    preview: 'Preview',
    
    // Calendar
    addEvent: 'Add Event',
    eventTitle: 'Event Title',
    eventType: 'Event Type',
    eventDate: 'Event Date',
    eventTime: 'Event Time',
    location: 'Location',
    courtSession: 'Court Session',
    deadline: 'Deadline',
    meeting: 'Meeting',
    reminder: 'Reminder',
    
    // Common
    save: 'Save',
    cancel: 'Cancel',
    search: 'Search',
    filter: 'Filter',
    export: 'Export',
    print: 'Print',
    noData: 'No data available',
    loading: 'Loading...',
    success: 'Success',
    error: 'Error',
    confirm: 'Confirm',
    actions: 'Actions',
    view: 'View',
    edit: 'Edit',
    active: 'Active',
    pending: 'Pending',
    closed: 'Closed',
    archived: 'Archived',
    all: 'All',
    createdAt: 'Created At',
    
    // Settings
    language: 'Language',
    theme: 'Theme',
    darkMode: 'Dark Mode',
    lightMode: 'Light Mode',
    profile: 'Profile',
    
    // Law Firm
    lawFirmManagement: 'Law Firm Management',
    lawFirm: 'Law Firm',
  },
  ar: {
    // Navigation
    dashboard: 'لوحة التحكم',
    cases: 'القضايا',
    clients: 'العملاء',
    employees: 'الموظفين',
    finance: 'المالية',
    documents: 'المستندات',
    calendar: 'التقويم',
    settings: 'الإعدادات',
    logout: 'تسجيل الخروج',
    
    // Auth
    login: 'تسجيل الدخول',
    username: 'اسم المستخدم',
    password: 'كلمة المرور',
    loginButton: 'دخول',
    loginError: 'بيانات الدخول غير صحيحة',
    welcomeBack: 'مرحباً بعودتك',
    signInToContinue: 'قم بتسجيل الدخول للمتابعة',
    
    // Dashboard
    totalCases: 'إجمالي القضايا',
    activeCases: 'القضايا النشطة',
    pendingCases: 'القضايا المعلقة',
    closedCases: 'القضايا المغلقة',
    totalClients: 'إجمالي العملاء',
    totalEmployees: 'إجمالي الموظفين',
    totalIncome: 'إجمالي الإيرادات',
    totalExpenses: 'إجمالي المصروفات',
    netProfit: 'صافي الربح',
    recentCases: 'أحدث القضايا',
    upcomingEvents: 'الأحداث القادمة',
    financialOverview: 'نظرة مالية عامة',
    
    // Cases
    caseNumber: 'رقم القضية',
    caseTitle: 'عنوان القضية',
    caseType: 'نوع القضية',
    caseStatus: 'الحالة',
    client: 'العميل',
    assignedLawyer: 'المحامي المكلف',
    courtName: 'اسم المحكمة',
    description: 'الوصف',
    notes: 'ملاحظات',
    createCase: 'إنشاء قضية',
    editCase: 'تعديل القضية',
    deleteCase: 'حذف القضية',
    caseDetails: 'تفاصيل القضية',
    
    // Clients
    clientName: 'اسم العميل',
    email: 'البريد الإلكتروني',
    phone: 'الهاتف',
    address: 'العنوان',
    idNumber: 'رقم الهوية',
    createClient: 'إضافة عميل',
    editClient: 'تعديل العميل',
    deleteClient: 'حذف العميل',
    clientDetails: 'تفاصيل العميل',
    linkedCases: 'القضايا المرتبطة',
    
    // Employees
    fullName: 'الاسم الكامل',
    role: 'الدور',
    admin: 'مدير',
    lawyer: 'محامي',
    assistant: 'مساعد',
    createEmployee: 'إضافة موظف',
    editEmployee: 'تعديل الموظف',
    deleteEmployee: 'حذف الموظف',
    employeeDetails: 'تفاصيل الموظف',
    
    // Finance
    income: 'إيراد',
    expense: 'مصروف',
    amount: 'المبلغ',
    date: 'التاريخ',
    category: 'الفئة',
    addTransaction: 'إضافة معاملة',
    transactionType: 'نوع المعاملة',
    financialReport: 'التقرير المالي',
    
    // Documents
    uploadDocument: 'رفع مستند',
    fileName: 'اسم الملف',
    fileSize: 'حجم الملف',
    uploadDate: 'تاريخ الرفع',
    download: 'تحميل',
    delete: 'حذف',
    preview: 'معاينة',
    
    // Calendar
    addEvent: 'إضافة حدث',
    eventTitle: 'عنوان الحدث',
    eventType: 'نوع الحدث',
    eventDate: 'تاريخ الحدث',
    eventTime: 'وقت الحدث',
    location: 'الموقع',
    courtSession: 'جلسة محكمة',
    deadline: 'موعد نهائي',
    meeting: 'اجتماع',
    reminder: 'تذكير',
    
    // Common
    save: 'حفظ',
    cancel: 'إلغاء',
    search: 'بحث',
    filter: 'تصفية',
    export: 'تصدير',
    print: 'طباعة',
    noData: 'لا توجد بيانات',
    loading: 'جاري التحميل...',
    success: 'نجاح',
    error: 'خطأ',
    confirm: 'تأكيد',
    actions: 'الإجراءات',
    view: 'عرض',
    edit: 'تعديل',
    active: 'نشط',
    pending: 'معلق',
    closed: 'مغلق',
    archived: 'مؤرشف',
    all: 'الكل',
    createdAt: 'تاريخ الإنشاء',
    
    // Settings
    language: 'اللغة',
    theme: 'المظهر',
    darkMode: 'الوضع الداكن',
    lightMode: 'الوضع الفاتح',
    profile: 'الملف الشخصي',
    
    // Law Firm
    lawFirmManagement: 'إدارة مكتب المحاماة',
    lawFirm: 'مكتب المحاماة',
  }
};

export const LanguageProvider = ({ children }) => {
  const [language, setLanguage] = useState(() => {
    return localStorage.getItem('language') || 'en';
  });

  const direction = language === 'ar' ? 'rtl' : 'ltr';

  useEffect(() => {
    localStorage.setItem('language', language);
    document.documentElement.setAttribute('dir', direction);
    document.documentElement.setAttribute('lang', language);
  }, [language, direction]);

  const t = (key) => {
    return translations[language][key] || key;
  };

  const toggleLanguage = () => {
    setLanguage(prev => prev === 'en' ? 'ar' : 'en');
  };

  return (
    <LanguageContext.Provider value={{ language, direction, setLanguage, toggleLanguage, t }}>
      {children}
    </LanguageContext.Provider>
  );
};

export const useLanguage = () => {
  const context = useContext(LanguageContext);
  if (!context) {
    throw new Error('useLanguage must be used within a LanguageProvider');
  }
  return context;
};

export default LanguageContext;
